import React from "react";
import { TimelineItem } from "./TimelineItem";
import { ListContainer, EmptyState } from "../index.styles";

export const TimelineList = ({ logs, isLoading, isError }) => {
  if (isLoading) {
    return <EmptyState>Loading activity history...</EmptyState>;
  }

  if (isError) {
    return <EmptyState>Failed to load activity history. Please try again.</EmptyState>;
  }

  if (!logs || logs.length === 0) {
    return <EmptyState>No activities found.</EmptyState>;
  }

  return (
    <ListContainer>
      {logs.map((log, index) => (
        <TimelineItem key={log.id || index} item={log} isLast={index === logs.length - 1} />
      ))}
    </ListContainer>
  );
};
